<template>
  <!-- Meet Our Doctors -->
  <section class="bg-gray-50 py-24">

    <!-- Heading -->
    <h2
      class="text-3xl md:text-4xl font-bold text-[#924f19] text-center mb-24 tracking-tight"
    >
      Meet Our Experienced Dentists in Guwahati
    </h2>

    <!-- Full-bleed visual area -->
    <div class="w-full mb-28">

      <!-- Unified Image + Message Card -->
      <div
        class="max-w-[1400px] mx-auto bg-white rounded-3xl shadow-xl
               grid md:grid-cols-2 overflow-hidden"
      >

        <!-- Image -->
        <div class="h-full">
          <img
            src="/doctors-together.webp"
            alt="Our dental specialists"
            class="w-full h-full object-cover"
          />
        </div>

        <!-- Message -->
        <div class="p-10 md:p-14 lg:p-16 flex items-center">
          <p
            class="font-serif text-gray-700 text-lg md:text-xl
                   leading-relaxed italic"
          >
            Magnum Dental Clinic, Guwahati is led by Dr. Monami Bujarbaruah and
            Dr. Dimpy Das, who have gained extensive experience working closely
            with patients across various reputed hospitals and clinics. Magnum
            Dental was established with the belief that dentistry should be humane,
            ethical, and transparent, ensuring every patient feels respected and
            well-informed. With strict sterilisation and hygiene protocols and a
            deep commitment to quality, Magnum Dental strives to provide care that
            feels safe, comfortable, and genuinely supportive—because every smile
            deserves thoughtful attention.
          </p>
        </div>

      </div>
    </div>

    <!-- Individual Doctors -->
    <div class="max-w-7xl mx-auto px-6">
      <div class="grid md:grid-cols-2 gap-16">

        <!-- Doctor 1 -->
        <div
          class="bg-white rounded-2xl shadow-md p-8 md:p-10
                 hover:shadow-lg transition"
        >
          <div class="text-center mb-8">
            <img
              src="/drMonamiNew.webp"
              alt="Dr. Monami Bujarbaruah"
              class="w-32 h-32 mx-auto rounded-full object-cover mb-6"
              style="object-position: center 30%"
            />

            <h3 class="text-xl font-semibold text-gray-800 mb-1">
              Dr. Monami Bujarbaruah
            </h3>

            <p class="text-sm text-teal-700 font-medium">
              BDS, MDS (Peridontist and Implantologist)
            </p>
          </div>

          <p class="text-gray-600 leading-relaxed text-center md:text-left">
            Dr. Monami Bujarbaruah is a Periodontist and Implantologist who focuses
            on restoring and preserving natural teeth, helping patients maintain
            long-term oral health with comfort and confidence. With experience in
            dental implants, she offers carefully planned tooth-replacement
            solutions designed for stability and function. Her clinical expertise
            also includes advanced gum treatments, surgical extractions, teeth
            whitening, and cosmetic dental procedures, among others. Dr. Monami is
            known for her gentle approach, clear communication, and personalised
            care, ensuring that every treatment is tailored to each patient’s
            needs and comfort.
          </p>
        </div>

        <!-- Doctor 2 -->
        <div
          class="bg-white rounded-2xl shadow-md p-8 md:p-10
                 hover:shadow-lg transition"
        >
          <div class="text-center mb-8">
            <img
              src="/drDimpy.webp"
              alt="Dr. Dimpy Das"
              class="w-32 h-32 mx-auto rounded-full object-cover mb-6"
              style="object-position: center 30%"
            />

            <h3 class="text-xl font-semibold text-gray-800 mb-1">
              Dr. Dimpy Das
            </h3>

            <p class="text-sm text-teal-700 font-medium">
              BDS (Experienced in Painless Root Canal Treatments and Cosmetic Dental Procedures)
            </p>
          </div>

          <p class="text-gray-600 leading-relaxed text-center md:text-left">
            Dr. Dimpy Das has extensive experience in painless root canal
            treatment, focusing on accuracy, comfort, and preserving natural
            teeth. She is known for her calm and reassuring manner, helping
            patients feel relaxed and confident throughout their treatment.
            Dr. Dimpy is skilled in managing pediatric patients with care and
            patience, ensuring a comfortable and positive dental experience.
            Along with RCTs, her clinical expertise includes restorative dental
            procedures, extractions, preventive care, and aesthetic dental
            treatments, delivered with precision and attention to detail.
            Dr. Dimpy is valued for her methodical approach to treatment. She
            remains focused on delivering precise care with consistent clinical
            outcomes.
          </p>
        </div>

      </div>
    </div>

  </section>
</template>

<script>
import { useHead } from "@vueuse/head";

export default {
  name: "MeetOurDoctors",
  setup() {
    useHead({
      title: "Experienced Dentists in Guwahati | Dr. Monami & Dr. Dimpy | Magnum Dental",
      meta: [
        {
          name: "description",
          content:
            "Meet Dr. Monami Bujarbaruah (Periodontist & Implantologist) and Dr. Dimpy Das (Root Canal Specialist) — experienced dentists at Magnum Dental Clinic, Guwahati.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Experienced Dentists in Guwahati | Magnum Dental Clinic",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/experienced-dentists-in-guwahati",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/experienced-dentists-in-guwahati" },
      ],
    });
  },
};
</script>
